import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tooltip from "..";
import Metric from "../../Metric";
import { appendTimezone, timestampRangeString } from "../../../lib/date";
import ChartTooltipAction from "../../ChartTooltipAction";
import Icon from "../../Icon";
import { formatNumber } from "../../../lib/number";
import style from "./style.module.scss";
export default function HeatMapTooltip(props) {
    const { cell, label, color, lowSampleRate, cellActionURL } = props;
    const actionsList = [];
    const lowSampleRateItem = [];
    if (cellActionURL !== "" && cellActionURL !== undefined && cell.value !== "-") {
        actionsList.push(_jsx(ChartTooltipAction, { icon: "eye", children: _jsx("a", { href: `${cellActionURL}`, children: "View Details" }) }));
    }
    let numPageViews = "";
    if (cell.num) {
        numPageViews = formatNumber(cell.num);
    }
    if (lowSampleRate) {
        lowSampleRateItem.push(_jsxs("div", { className: style["heatmap-tooltip__low-sample-rate"], children: [_jsxs("div", { className: style["heatmap-tooltip__low-sample-rate__title"], children: [_jsx(Icon, { name: "help" }), " Low Data Sample"] }), _jsxs("div", { children: ["This is a small data sample (", numPageViews, " ", cell.series.numLabel, "). This metric value is unlikely to be accurate."] })] }));
    }
    return (_jsxs(Tooltip, { className: style["heatmap-tooltip"], footer: actionsList, children: [appendTimezone(timestampRangeString(cell.series.startTime, cell.series.endTime)), Number(cell.num) > 0 && _jsx("div", { children: `${numPageViews} ${cell.series.numLabel}` }), label !== undefined && _jsx("div", { style: { color }, children: label.label }), _jsx(TooltipContent, { cell: cell, series: cell.series, color: color }), lowSampleRateItem] }));
}
function TooltipContent(props) {
    const { cell, series, color } = props;
    let suffix = series.suffix;
    if (cell.value === "-") {
        suffix = "";
    }
    return _jsx(Metric, { color: color, title: series.name, value: `${cell.value}${suffix}` });
}
